import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../Colors';
import Navigation from '../components/Navigation';
import { imageApi } from '../services/api';

function ImageFromTextImage() {
  const [text, setText] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Validate inputs
    if (!text.trim()) {
      setError('Veuillez entrer un prompt ou du texte.');
      return;
    }
    
    if (!selectedImage) {
      setError('Veuillez sélectionner une image.');
      return;
    }
    
    setLoading(true);
    setError(null);
    setResult(null);
    
    try {
      // Convert image file to base64
      const base64Image = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(selectedImage);
      });
      
      const data = await imageApi.editImage({
        prompt: text,
        images_input: [base64Image]
      });
      
      if (data.success) {
        setResult(data.data);
        console.log('Success:', data.data);
      } else {
        throw new Error(data.message || 'Le traitement a échoué');
      }
      
    } catch (err) {
      console.error('Error:', err);
      setError(err.message || 'Une erreur est survenue lors du traitement de l\'image.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: colors.background.main }}>
      <Navigation />
      <main style={{ padding: '20px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ 
        background: 'rgba(255, 255, 255, 0.98)', 
        borderRadius: '24px', 
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.08)', 
        padding: '24px 35px 35px 35px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        overflow: 'hidden',
        height: '100%'
      }}>
        <div style={{ marginBottom: '20px' }}>
          <Link to="/" style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            fontSize: '0.9rem',
            fontWeight: '600',
            borderRadius: '20px',
            cursor: 'pointer',
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            ← Retour à l'accueil
          </Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '35px', 
            alignItems: 'start',
            marginBottom: '20px',
            width: '100%',
            maxWidth: '100%'
          }}>
            {/* Left side - Image Upload */}
            <div style={{ width: '100%', maxWidth: '100%' }}>
              <label style={{ 
                fontSize: '1.1rem', 
                fontWeight: '600', 
                color: colors.text.primary,
                display: 'block',
                marginBottom: '14px'
              }}>
                Télécharger l'image :
              </label>
              
              {!imagePreview ? (
                <div
                  style={{
                    border: `2px dashed ${colors.border.light}`,
                    borderRadius: '16px',
                    padding: '22px 18px',
                    textAlign: 'center',
                    backgroundColor: colors.background.accent,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    width: '100%',
                    maxWidth: '100%',
                    height: '280px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                    aspectRatio: '1'
                  }}
                  onClick={() => document.getElementById('image-upload').click()}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = colors.primary.main;
                    e.target.style.backgroundColor = colors.background.secondary;
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = colors.border.light;
                    e.target.style.backgroundColor = colors.background.accent;
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  <div style={{ fontSize: '2.2rem', marginBottom: '14px', color: colors.primary.main }}>📁</div>
                  <p style={{ fontSize: '1rem', color: colors.text.secondary, marginBottom: '7px', fontWeight: '500' }}>
                    Cliquez pour télécharger une image
                  </p>
                  <p style={{ fontSize: '0.9rem', color: colors.text.light, fontStyle: 'italic' }}>
                    ou glissez-déposez ici
                  </p>
                </div>
              ) : (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  backgroundColor: colors.background.accent, 
                  borderRadius: '16px', 
                  padding: '18px', 
                  border: `2px solid ${colors.border.light}`,
                  position: 'relative',
                  width: '100%',
                  maxWidth: '100%',
                  height: '280px',
                  alignItems: 'center',
                  boxSizing: 'border-box',
                  aspectRatio: '1'
                }}>
                  <img 
                    src={imagePreview} 
                    alt="Aperçu" 
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      borderRadius: '12px',
                      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
                      objectFit: 'contain'
                    }}
                  />
                  <button
                    type="button"
                    onClick={handleRemoveImage}
                    style={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      background: 'rgba(239, 68, 68, 0.9)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '26px',
                      height: '26px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      transition: 'all 0.2s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(239, 68, 68, 1)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'rgba(239, 68, 68, 0.9)';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    ×
                  </button>
                </div>
              )}
              
              <input
                id="image-upload"
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                style={{ display: 'none' }}
              />
            </div>

            {/* Right side - Text Input */}
            <div style={{ width: '100%', maxWidth: '100%' }}>
              <label style={{ 
                fontSize: '1.1rem', 
                fontWeight: '600', 
                color: colors.text.primary,
                display: 'block',
                marginBottom: '14px'
              }}>
                Entrez votre prompt ou texte ici :
              </label>
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Écrivez votre prompt, instructions ou tout contenu textuel ici..."
                rows="8"
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  minHeight: '280px',
                  padding: '18px',
                  border: `2px solid ${colors.border.light}`,
                  borderRadius: '16px',
                  fontSize: '1rem',
                  fontFamily: 'inherit',
                  resize: 'vertical',
                  backgroundColor: colors.background.accent,
                  transition: 'all 0.2s ease',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = colors.primary.main;
                  e.target.style.backgroundColor = 'white';
                  e.target.style.boxShadow = '0 0 0 3px rgba(90, 108, 125, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = colors.border.light;
                  e.target.style.backgroundColor = colors.background.accent;
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          </div>

          {/* Error Display */}
          {error && (
            <div style={{
              backgroundColor: '#fee2e2',
              border: '1px solid #fecaca',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '20px',
              color: '#dc2626'
            }}>
              <strong>❌ Erreur:</strong> {error}
            </div>
          )}

          {/* Result Display */}
          {result && (
            <div style={{
              backgroundColor: '#f0fdf4',
              border: '1px solid #bbf7d0',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '20px',
              color: '#166534'
            }}>
              <strong>✅ Succès!</strong> Image traitée avec succès.
              
              {/* Display the generated image */}
              {result.img_generated_url && (
                <div style={{ marginTop: '16px' }}>
                  <h4 style={{ margin: '0 0 12px 0', color: '#166534' }}>Image générée :</h4>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    padding: '16px',
                    border: '2px solid #bbf7d0'
                  }}>
                    <img 
                      src={result.img_generated_url} 
                      alt="Image générée" 
                      style={{
                        maxWidth: '100%',
                        maxHeight: '400px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <div 
                      style={{ 
                        display: 'none',
                        padding: '20px',
                        textAlign: 'center',
                        color: '#dc2626',
                        backgroundColor: '#fee2e2',
                        borderRadius: '8px',
                        border: '1px solid #fecaca'
                      }}
                    >
                      ❌ Erreur de chargement de l'image
                    </div>
                  </div>
                  
                  {/* Download link */}
                  <div style={{ textAlign: 'center', marginTop: '12px' }}>
                    <a 
                      href={result.img_generated_url} 
                      download 
                      style={{
                        display: 'inline-block',
                        backgroundColor: '#166534',
                        color: 'white',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        textDecoration: 'none',
                        fontSize: '0.9rem',
                        fontWeight: '500'
                      }}
                    >
                      📥 Télécharger l'image
                    </a>
                  </div>
                </div>
              )}
              
              {/* Display prompt used */}
              {result.prompt && (
                <div style={{ marginTop: '16px' }}>
                  <h4 style={{ margin: '0 0 8px 0', color: '#166534' }}>Prompt utilisé :</h4>
                  <div style={{
                    backgroundColor: 'rgba(0,0,0,0.05)',
                    padding: '12px',
                    borderRadius: '6px',
                    fontStyle: 'italic',
                    color: '#374151'
                  }}>
                    "{result.prompt}"
                  </div>
                </div>
              )}
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '8px' }}>
            <button
              type="submit"
              disabled={loading}
              style={{
                background: loading 
                  ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'
                  : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                padding: '16px 36px',
                fontSize: '1.05rem',
                fontWeight: '600',
                borderRadius: '50px',
                cursor: loading ? 'not-allowed' : 'pointer',
                minWidth: '190px',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
                opacity: loading ? 0.7 : 1
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                }
              }}
            >
              {loading ? '⏳ Traitement...' : 'Traiter l\'image'}
            </button>
          </div>
        </form>
      </div>
        </div>
      </main>
    </div>
  );
}

export default ImageFromTextImage;
